import { Stack } from '@carbon/react';
import cx from 'clsx';

import styles from 'theme/components/form-actions.module.scss';

const FormActions = ({ children, sticky = false, className }) => (
  <Stack
    gap={7}
    orientation="horizontal"
    className={cx(styles.wrapper, sticky && styles['wrapper--sticky'], className)}
  >
    {children}
  </Stack>
);

export default FormActions;
